import { a as _objectWithoutProperties, k as _objectSpread2, e as _defineProperty, b as _extends } from '../_rollupPluginBabelHelpers-6a814b33.js';
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { s as styleInject } from '../style-inject.es-a0e1a0ba.js';
import cx from 'classnames';
import { g as globalPropTypes } from '../globalPropTypes-bb98efc9.js';
import { g as globalClasses } from '../globalClasses-ae52730b.js';
import { makeQAStates, makeQAAttributes } from '../utils/qaAttributes.js';
import './Icon.js';
import CheckMarkIcon from '../icons/CheckMark.js';

var css_248z = ".checkbox_1CY3Sn{display:inline-block;line-height:0;vertical-align:middle;-webkit-tap-highlight-color:transparent}.checkbox_1CY3Sn:not(.is-disabled_lmjPEx){cursor:pointer}.checkbox_1CY3Sn:focus,.checkbox__body_1mRcRd:focus{outline:none}.checkbox__body_1mRcRd{display:flex;align-items:inherit;justify-content:inherit}@media (hover),(min--moz-device-pixel-ratio:0),(min-width:0\\0){.checkbox_1CY3Sn:focus-within .checkbox__indicator_-NJMuJ{z-index:2;box-shadow:0 0 0 2px #8acbff}}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.checkbox_1CY3Sn[class*=focus-within] .checkbox__indicator_-NJMuJ{z-index:2;box-shadow:0 0 0 2px #8acbff}}.checkbox__indicator_-NJMuJ{position:relative;z-index:1;width:1em;height:1em;flex-shrink:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;box-sizing:border-box;display:flex;align-items:center;justify-content:center;flex-direction:column}.checkbox_1CY3Sn.is-disabled_lmjPEx .checkbox__indicator_-NJMuJ{cursor:not-allowed}.theme-primary_2scxhT .checkbox__indicator_-NJMuJ{color:#fff;border-radius:.25em;border:1px solid #aaa;background-color:#fff}@media (hover),(min--moz-device-pixel-ratio:0),(min-width:0\\0){.theme-primary_2scxhT:not(.is-disabled_lmjPEx) .checkbox__indicator_-NJMuJ:hover{border-color:#ff9000}}.theme-primary_2scxhT:not(.is-disabled_lmjPEx):not(.is-checked_1AP5oq) .checkbox__indicator_-NJMuJ:active{box-shadow:inset 0 0 .1875em rgba(0,0,0,.25)}.theme-primary_2scxhT.is-checked_1AP5oq.is-disabled_lmjPEx .checkbox__indicator_-NJMuJ{background-color:#ffe3bf;border-color:#ffe3bf}.theme-primary_2scxhT.is-checked_1AP5oq:not(.is-disabled_lmjPEx) .checkbox__indicator_-NJMuJ{background-color:#ff9000;border-color:#ff9000}@media (hover),(min--moz-device-pixel-ratio:0),(min-width:0\\0){.theme-primary_2scxhT.is-checked_1AP5oq:not(.is-disabled_lmjPEx):hover .checkbox__indicator_-NJMuJ{background-color:#ffa42e;border-color:#ffa42e}}.theme-primary_2scxhT.is-checked_1AP5oq:not(.is-disabled_lmjPEx):active .checkbox__indicator_-NJMuJ{background-color:#f08700;border-color:#f08700}.theme-primary_2scxhT.is-disabled_lmjPEx:not(.is-checked_1AP5oq) .checkbox__indicator_-NJMuJ{background-color:#f5f5f5;color:#f5f5f5}.theme-transparent-orange_25Iq49:not(.is-disabled_lmjPEx) .checkbox__indicator_-NJMuJ{background-color:rgba(255,144,0,.2);color:transparent}@media (hover),(min--moz-device-pixel-ratio:0),(min-width:0\\0){.theme-transparent-orange_25Iq49:not(.is-disabled_lmjPEx) .checkbox__indicator_-NJMuJ:hover{background-color:rgba(255,144,0,.25)}}.theme-transparent-orange_25Iq49:not(.is-disabled_lmjPEx) .checkbox__indicator_-NJMuJ:active{background-color:rgba(255,144,0,.3)}.theme-transparent-orange_25Iq49.is-checked_1AP5oq.is-disabled_lmjPEx .checkbox__indicator_-NJMuJ{background-color:hsla(0,0%,50.2%,.2)}.theme-transparent-orange_25Iq49.is-checked_1AP5oq:not(.is-disabled_lmjPEx) .checkbox__indicator_-NJMuJ{background-color:rgba(255,144,0,.2);color:#444}@media (hover),(min--moz-device-pixel-ratio:0),(min-width:0\\0){.theme-transparent-orange_25Iq49.is-checked_1AP5oq:not(.is-disabled_lmjPEx):hover .checkbox__indicator_-NJMuJ{background-color:rgba(255,144,0,.25)}}.theme-transparent-orange_25Iq49.is-checked_1AP5oq:not(.is-disabled_lmjPEx):active .checkbox__indicator_-NJMuJ{background-color:rgba(255,144,0,.3)}.theme-transparent-orange_25Iq49.is-required_FcYQCr .checkbox__indicator_-NJMuJ{background-color:rgba(255,87,34,.2)}@media (hover),(min--moz-device-pixel-ratio:0),(min-width:0\\0){.theme-transparent-orange_25Iq49.is-required_FcYQCr .checkbox__indicator_-NJMuJ:hover{background-color:rgba(255,87,34,.25)}}.theme-transparent-orange_25Iq49.is-required_FcYQCr .checkbox__indicator_-NJMuJ:active{background-color:rgba(255,87,34,.3)}.theme-transparent-orange_25Iq49.is-required_FcYQCr.is-checked_1AP5oq{color:#444}.theme-transparent-orange_25Iq49.is-disabled_lmjPEx:not(.is-checked_1AP5oq) .checkbox__indicator_-NJMuJ{background-color:#f5f5f5;color:#f5f5f5}";
var styles = {"checkbox":"checkbox_1CY3Sn","is-disabled":"is-disabled_lmjPEx","checkbox__body":"checkbox__body_1mRcRd","checkbox__indicator":"checkbox__indicator_-NJMuJ","theme-primary":"theme-primary_2scxhT","is-checked":"is-checked_1AP5oq","theme-transparent-orange":"theme-transparent-orange_25Iq49","is-required":"is-required_FcYQCr"};
styleInject(css_248z);

var Checkbox = forwardRef(function (_ref, ref) {
  var _cx;

  var id = _ref.id,
      ariaLabel = _ref.ariaLabel,
      css = _ref.css,
      checked = _ref.checked,
      disabled = _ref.disabled,
      required = _ref.required,
      label = _ref.label,
      name = _ref.name,
      indicatorIcon = _ref.indicatorIcon,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ["id", "ariaLabel", "css", "checked", "disabled", "required", "label", "name", "indicatorIcon", "onChange"]);

  var mergedCSS = _objectSpread2({}, Checkbox.defaultProps.css, {}, css);

  var theme = mergedCSS.theme,
      alignItems = mergedCSS.alignItems,
      justifyContent = mergedCSS.justifyContent;
  var componentClassName = cx(styles.checkbox, (_cx = {}, _defineProperty(_cx, styles["theme-".concat(theme)], theme), _defineProperty(_cx, styles['is-checked'], checked), _defineProperty(_cx, styles['is-disabled'], disabled), _defineProperty(_cx, styles['is-required'], required), _cx), globalClasses({
    alignItems: alignItems,
    justifyContent: justifyContent
  }));
  return /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: componentClassName
  }, /*#__PURE__*/React.createElement("input", _extends({
    id: id,
    type: "checkbox",
    checked: checked,
    onChange: onChange,
    className: cx(globalClasses({
      visuallyHidden: Boolean(true)
    })),
    readOnly: true,
    name: name,
    disabled: disabled,
    "aria-label": ariaLabel,
    ref: ref
  }, makeQAStates({
    checked: checked,
    disabled: disabled
  }), props)), /*#__PURE__*/React.createElement("span", {
    className: styles.checkbox__body
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.checkbox__indicator
  }, indicatorIcon || /*#__PURE__*/React.createElement(CheckMarkIcon, null)), label && /*#__PURE__*/React.createElement("span", {
    className: styles.checkbox__label
  }, label)));
});
Checkbox.propTypes = {
  id: PropTypes.string,

  /** This option needs for accessibility. Important use it */
  ariaLabel: PropTypes.string,

  /** Set checkbox checked state */
  checked: PropTypes.bool,

  /** Set checkbox disabled state */
  disabled: PropTypes.bool,
  required: PropTypes.bool,

  /** Set checkbox name attribute value */
  name: PropTypes.string,

  /** Set classes using props */
  css: PropTypes.shape({
    /** Setting theme, 'primary' is by default */
    theme: PropTypes.oneOf(['primary', 'transparent-orange']),

    /** If flex direction is 'row',
     * alignment items flex-start, center, flex-end */
    alignItems: globalPropTypes('alignItems'),

    /** If flex direction is 'row',
     * justified items flex-start, center, flex-end, space-between */
    justifyContent: globalPropTypes('justifyContent')
  }),

  /** Add custom icon for indicator */
  indicatorIcon: PropTypes.element,

  /** You can use some component like label */
  label: PropTypes.element,
  onChange: PropTypes.func
};
Checkbox.defaultProps = _objectSpread2({
  id: null,
  ariaLabel: '',
  name: '',
  checked: false,
  disabled: false,
  required: false,
  css: {
    theme: 'primary',
    alignItems: 'center',
    justifyContent: null
  },
  indicatorIcon: null,
  label: null,
  onChange: function onChange() {}
}, makeQAAttributes('checkbox'));

export default Checkbox;
//# sourceMappingURL=Checkbox.js.map
